import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map, mapTo } from "rxjs/operators";

import { Rolle } from "@e-forsyning/common/bruger";
import { InstallationHttpClient, ParametreForAktuelleInstallation } from "@e-forsyning/common/http";
import { IInstallationsoplysninger } from "@e-forsyning/common/installation";

@Injectable({ providedIn: "root" })
export class ValgtInstallationRepository {
    constructor(private readonly http: InstallationHttpClient) {}

    public hentInstallationsoplysninger(): Observable<IInstallationsoplysninger> {
        return this.http
            .get("api/getebrugerinfo", ParametreForAktuelleInstallation.true)
            .pipe(map((installationsoplysningerFof: any) => this.mapTo(installationsoplysningerFof)));
    }

    public async redigerMail(mail: string): Promise<void> {
        return this.redigerBrugeroplysning("EMAIL", mail);
    }

    public async redigerTelefonnummer(telefonnummer: string): Promise<void> {
        return this.redigerBrugeroplysning("TLF", telefonnummer);
    }

    public async redigerBeboeremail(beboeremail: string): Promise<void> {
        return this.redigerBrugeroplysning("BEBOEREMAIL", beboeremail);
    }

    private async redigerBrugeroplysning(type: "TLF" | "EMAIL" | "BEBOEREMAIL", value: string): Promise<void> {
        const data = {
            [type.toLowerCase()]: value,
            toUpdate: type
        };
        return await this.http
            .postWithStringResult("api/updateebruger", data, ParametreForAktuelleInstallation.true)
            .pipe(mapTo(null))
            .toPromise();
    }

    private mapTo(installationsoplysningerFof: any): IInstallationsoplysninger {
        return {
            ejendomnr: installationsoplysningerFof.ejendomnr,
            navn: installationsoplysningerFof.navn,
            navn2: installationsoplysningerFof.navn2,
            vejnavn: installationsoplysningerFof.vej,
            husnr: installationsoplysningerFof.husnr,
            litra: installationsoplysningerFof.litra,
            litra2: installationsoplysningerFof.litra2,
            postnr: installationsoplysningerFof.postnr,
            telefonnr: installationsoplysningerFof.tlf,
            beboeremail: installationsoplysningerFof.beboeremail,
            bynavn: installationsoplysningerFof.bynavn,
            mail: installationsoplysningerFof.email,
            id: installationsoplysningerFof.id,
            rolle: installationsoplysningerFof.rolle as Rolle,
            ejerNavn: installationsoplysningerFof.ejerNavn
        };
    }
}
